import type { MeProfile, Page, PromptCard } from '@promptvault/shared';
import { apiFetch } from './client';

export function fetchMe(): Promise<MeProfile> {
  return apiFetch<MeProfile>('/me');
}

export function fetchFavorites(cursor?: string): Promise<Page<PromptCard>> {
  return apiFetch<Page<PromptCard>>('/me/favorites', { params: { cursor } });
}

export function patchSettings(settings: {
  language?: 'en' | 'fa';
  nsfwVisible?: boolean;
  notifications?: boolean;
}): Promise<MeProfile> {
  return apiFetch<MeProfile>('/me/settings', {
    method: 'PATCH',
    body: JSON.stringify(settings),
  });
}
